export default "__VITE_ASSET__BRtFFzX5__"